declare global {
    interface DocumentEventMap {
        collectionFieldItemAdded: CustomEvent<{ $item: HTMLElement }>;
        collectionFieldItemRemoved: CustomEvent<{ $item: HTMLElement }>;
    }
}

export function initCollectionFields(): void {
    document.querySelectorAll<CollectionHolderHTMLElement>('.js-collection-holder').forEach($collectionHolder => {
        if (!$collectionHolder.dataset.prototype) {
            return;
        }

        new CollectionHolder($collectionHolder);
    });
}

export interface CollectionHolderHTMLElement extends HTMLElement {
    dataset: HTMLElement['dataset'] & {
        prototype: string;
        counter: string;
        deletePrototype?: string;
    };
}

class CollectionHolder {
    $collectionHolder: CollectionHolderHTMLElement;

    constructor($collectionHolder: CollectionHolderHTMLElement) {
        this.$collectionHolder = $collectionHolder;

        document.addEventListener('click', evt => {
            const $targetEl = evt.target as HTMLElement;

            if ($targetEl.closest('.add-collection-item')) {
                const $target = $targetEl.closest('.add-collection-item') as HTMLElement;
                const collectionHolderId = $target.dataset?.collectionHolder;

                if (collectionHolderId !== this.$collectionHolder.getAttribute('id')) {
                    return;
                }

                let counter = parseInt(this.$collectionHolder.dataset.counter ?? '0');
                counter++;

                const deleteButton = (this.$collectionHolder.dataset.deletePrototype ?? '')
                    .replace(/__collection_id__/g, collectionHolderId);

                const newItem = this.$collectionHolder.dataset.prototype
                    .replace(/__name__/g, counter.toString())
                    .replace(/__index__/g, (counter + 1).toString())
                    .replace(/__remove_btn__/g, deleteButton);

                this.$collectionHolder.dataset.counter = counter.toString();

                const $item = document.createElement('div');
                $item.classList.add('collection-item');
                $item.innerHTML = newItem;

                this.$collectionHolder.appendChild($item);

                document.dispatchEvent(new CustomEvent('collectionFieldItemAdded', {
                    detail: { $item },
                }));
            } else if ($targetEl.closest('.remove-collection-item')) {
                const $target = $targetEl.closest('.remove-collection-item') as HTMLElement;
                const collectionHolderId = $target.dataset?.collectionHolder;

                if (collectionHolderId !== this.$collectionHolder.getAttribute('id')) {
                    return;
                }

                const $item = $target.closest('.collection-item') as HTMLElement;
                $item.remove();

                document.dispatchEvent(new CustomEvent('collectionFieldItemRemoved', {
                    detail: { $item },
                }));
            }
        });
    }
}
